import React from "react";
import { Margin, Title, Text } from "~/components/elements";

export default function EmailUpdated({ mobile, email, handleModal }) {
  return (
    <>
      <Margin mb={2}>
        <Title level="5" as="3">
          ¡El correo electrónico se cambió con éxito!
        </Title>
      </Margin>
      <Margin>
        <Text primary level={2}>
          Recibirás nuestras comunicaciones en tu nuevo e-mail{" "}
          <strong>{email}</strong>. Debes iniciar sesión para ingresar a tu
          cuenta con tu nuevo e-mail.
        </Text>
      </Margin>
    </>
  );
}
